export const environment = {
  production: false,

  // Base URLs
  apiUrl: 'https://api.test.rapicredit.com/',
  apiGatewayUrl: 'https://api-backend.test.rapicredit.com/',
  apiBackDebtUrl: 'https://back-debt-backend.test.rapicredit.com/v1/',
  apiDailyBalance: 'https://api-backend.test.rapicredit.com/back-dailybalance/',
  apiBackDebtUrlNovation: 'https://back-debt-backend.test.rapicredit.com/',

  // Landing URLs
  landingRapiplazo: 'https://frontlandingst.test.rapicredit.com/',
  landingRapiflex: 'https://home.test.rapicredit.com/',

  // Application URLs
  clientRapiplazo: 'https://frontlendingst.test.rapicredit.com/',
  myCreditsRapiflex: 'https://micredito.test.rapicredit.com/',
  onboardingRapiflex: 'https://playrefactor.rapicredit.com/app/',
  sessionlessPaymentUrl: 'https://sessionlesspayments.test.rapicredit.com/',
  alliancesUrl: 'https://alianzas.test.rapicredit.com/',

  // Domain
  domain: '.rapicredit.com',

  // Novation type Id's
  novationTypeId: {
    RP: '6cc3052bd65311eeafb016428df9c65f',
    RF: '688d2ccfd65311eeafb016428df9c65f',
    RNE: '0f4baf83a85411efadda0e54148beb9d',
  },

  // Google Keys
  recaptchaV3SiteKey: '6LekbKEUAAAAAKRd8rcDe67RZoiTZcK7Gr8b_K9J',
  googleApiPlacesKey: 'AIzaSyAU00CDNsBKO2Cck7A5XFC7uX3bph-9kvs',

  // Asopagos URLs
  asopagosUrl: 'https://secure.payzen.lat/vads-payment/',
  heritageApiKey: 'RUyuLebHu376sRYf7NdXc91px4vRqK9Hyvsbiswa',

  // Wompi Envs
  wompiCurrency: 'COP',
  wompiPublicKey: 'pub_test_yqYeDay9EkJyKEPysGNAkKM61DYYlhsV',

  // CredoLab Envs
  credoLabUrl: 'https://scoring-demo.credolab.com/',
  credoLabKey: 'c3e7b6c3-83df-41fe-921e-41266efd3beb',

  // WebElements Url
  webElementsUrl: 'https://webelements.test.rapicredit.com/web-elements/',
  cacheBuster: '1764283125533',

  // Enable Google Tag Manager
  enableGTM: false,

  // resources mis creditos
  myCreditsResourcesUrl: 'https://miscreditosresources.test.rapicredit.com/',

  // Secret Key Referrals
  secretKeyReferrals: 'jEEdOx2GMR4lWrhr1UFozGdbpjWdtpslu18epcoOk5pIbLda26P6W0Q3CVO3Wq+A',

  // Firebase Configuration
  firebase: {
    apiKey: 'AIzaSyBPV7pGMaUHI9Cn0o87gfQg9p8D70qSy7Q',
    authDomain: 'rc-insurance-notificatio-77d9f.firebaseapp.com',
    projectId: 'rc-insurance-notificatio-77d9f',
    storageBucket: 'rc-insurance-notificatio-77d9f.firebasestorage.app',
    messagingSenderId: '972942316847',
    appId: '1:972942316847:web:f199977de7c5ebd123bdda',
  },
};
